module.exports = __webpack_public_path__ + "static/media/sushiswap.6a198ab7.svg";